import React, { useState } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import _get from 'lodash-es/get';
import Tooltip from 'sushiweb/Tooltip/Tooltip';

import {
  FORCESERVER,
  ONLINE,
  currentFlowTypeEnum,
  cycleTypeEnum,
  eventsAmountEnum,
  invoicesStatusEnum,
  paymentRequestEnum,
  sourceToCreditType,
  statusLabels,
  topupsStatusEnum,
  weekDays,
  wrongFormat,
} from '../pages/common/components/constants';
import { enumSlots, slotType } from '../pages/WalletPrograms/constants';
import { FormatTimeWrapper } from '../pages/common/styles';
import OnlinePaymentModal from '../pages/common/components/OnlinePaymentModal';
import {
  InvoiceOnlineContainer,
  StatusContainer,
} from '../pages/common/components/DataTables/styles';

export const initialiseLoginSDKs = () => {
  const script = document.createElement('script');
  script.src = process.env.REACT_APP_AUTH_SDK_URL;
  script.async = true;
  document.body.appendChild(script);
  script.onload = () => {
    if (window.zoauth !== undefined) {
      window.zoauth
        .init(process.env.REACT_APP_AUTH_CLIENT_ID, '', 'offline', {
          LOGIN_METHODS: ['email', 'google'],
          // THEME: 'CF_INVITE_THEME',
        })
        .then(success => {
          console.log(success);
        });
    }
  };
};

export const isUserLoggedIn = data => {
  let numericUserId = Number(_get(data, 'user_id', 0));
  numericUserId = Number.isNaN(numericUserId) ? 0 : numericUserId;
  const name = _get(data, 'name', '');
  // const email = _get(data, 'email', '');
  return Boolean(numericUserId && name);
};

export const arrayToObject = (arr, keyField) =>
  Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

export const copyrightLabel = () => {
  const year = new Date().getFullYear();
  return `© 2008-${year} - Zomato™ Pvt Ltd.`;
};

export const displayDateFormat = str => {
  const completeDate = new Date(str);
  const currentDate = str.split(' ')[0];
  const [date, month] = currentDate.split('-');
  const fullYear = `${completeDate.getFullYear()}`;
  const newYear = fullYear.substring(2);
  return [date, month, newYear].join('-');
};

export const formatDate = date => {
  const currentDate = new Date(date);
  let month = `${currentDate.getMonth() + 1}`;
  let day = `${currentDate.getDate()}`;
  const year = `${currentDate.getFullYear()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
};

export const processDate = date => {
  const dateParts = date.split('-');
  return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
};

export const dateStringFormat = date => {
  return date
    .split(' ')[0]
    .split('-')
    .join(' ');
};

export const formatMonth = date => {
  const currentDate = new Date(date);
  let month = `${currentDate.getMonth() + 1}`;
  const year = `${currentDate.getFullYear()}`;

  if (month.length < 2) month = `0${month}`;

  return [year, month].join('-');
};

export const formatTime = data => {
  return (
    <FormatTimeWrapper>
      <p>{data.split(' ')[0]}</p>
      <p>{data.split(' ')[1] ? data.split(' ')[1] : null}</p>
    </FormatTimeWrapper>
  );
};
export const newFormatTime = data => {
  return (
    <>
      {data.split(' ')[0]}
      {data.split(' ')[1] ? ` | ` : null}
      {data.split(' ')[1]}
    </>
  );
};
export const formatDateWithoutTime = data => {
  return <>{data.split(' ')[0]}</>;
};
export const ISOtoLongDate = data => {
  const d = new Date(data.split(' '));
  return d.toDateString().split('');
};

export const getMonthAndYearFromDate = (date, withComma) => {
  if (!date || date === undefined) {
    return ' ';
  }
  const d = new Date(date.split(' ')[0]);
  const month = d.toLocaleString('default', {
    month: 'long',
  });
  const year = d.toLocaleString('default', {
    year: '2-digit',
  });
  if (withComma) {
    return `${month}, ${year}`;
  }
  return `${month} ${year}`;
};

export const formatDateinLocalFormat = d => {
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  const year = d.toLocaleString('default', {
    year: '2-digit',
  });
  return `${d.getDate()}-${MMM}-${year}`;
};

export const formatDateinDDMMMYYY = data => {
  const d = new Date(data.split(' ')[0]);
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  const year = d.toLocaleString('default', {
    year: 'numeric',
  });
  return `${d.getDate()}-${MMM}-${year}`;
};

export const formatDateInDateOrdinalFormat = date => {
  const d = new Date(date.split(' ')[0]);
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  return `${d.getDate()}${getOrdinal(d.getDate())} ${MMM} ${d.getFullYear()}`;
};

export const getTimeFromDate = date => {
  const dateSplit = date.split(' ');
  if (dateSplit.length < 2) return ' ';
  if (dateSplit[1].length < 8) {
    return dateSplit[1];
  }
  return dateSplit[1].substring(0, 8);
};

export const convertTo12HourFormat = time24 => {
  // Split the time into hours and minutes
  const splitTime = time24.split(':');
  let hours = parseInt(splitTime[0], 10);
  const minutes = splitTime[1];

  // Determine whether it's AM or PM
  const period = hours < 12 ? 'AM' : 'PM';

  // Adjust hours to 12-hour format
  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${period}`;
};

export const formatDateinDDMMMYYYAndTime = date => {
  const dateArr = date.split(' ');
  if (dateArr.length === 0) {
    return ' ';
  }
  const d = new Date(dateArr[0]);
  const formattedDate = formatDateinLocalFormat(d);
  if (dateArr.length === 1) {
    return formattedDate;
  }
  const formattedTime = convertTo12HourFormat(dateArr[1]);
  return `${formattedDate} | ${formattedTime} `;
};

export const formatDateTime = date => {
  return `${formatDateinDDMMMYYY(date)} ${getTimeFromDate(date)}`;
};
export const formatDateForInfoSections = data => {
  const d = new Date(data.split(' ')[0]);
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  return `${d.getDate()} ${MMM}, ${d.getFullYear()}`;
};
export const ISOtoLongDateTime = data => {
  const d = new Date(data);
  return d.toDateString();
};
export const getDailyAmount = slots => {
  let totalAmount = 0;
  slots.forEach(slot => {
    const slotAmount = slot?.amount && slot?.amount !== '' ? slot?.amount : '0';
    totalAmount += parseFloat(slotAmount);
  });
  return totalAmount;
};
export const getEmployeesCountFromGroups = groups => {
  let employeesCount = 0;
  groups.forEach(group => {
    employeesCount += group.employees;
  });
  return employeesCount;
};
export const getFormattedEndDate = endDate => {
  const currentDate = new Date(endDate);
  const year = `${currentDate.getFullYear()}`;
  // we get date as 01/01/3000 in never ends case
  if (year === '3000') return 'NA';
  return endDate;
};
export const validateName = name => {
  const re = /^[a-zA-Z0-9 ()@-]+$/;
  return re.test(String(name).toLowerCase());
};

export const validateEmployeeName = name => {
  const re = /^[A-Za-z0-9? ,_-]+$/;
  return re.test(String(name));
};

export const commaCsvChecks = data => {
  const re = /[;,]/g;
  return re.test(data);
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  return currentDate
    .toLocaleDateString()
    .split('/')
    .join('-');
};

export const getTimeIn12HRFormat = time => {
  let formattedTime = time
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (formattedTime.length > 1) {
    formattedTime = formattedTime.slice(1);
    formattedTime[5] = +formattedTime[0] < 12 ? 'AM' : 'PM';
    formattedTime[0] = +formattedTime[0] % 12 || 12;
  }
  return formattedTime.join('');
};

export const slotTimeValidation = slots => {
  for (let i = 0; i < slots.length; i += 1) {
    const slot = slots[i];
    if (slot.startTime < enumSlots[slotType[slot.type]].startTime) {
      return false;
    }
    if (slot.endTime > enumSlots[slotType[slot.type]].endTime) {
      return false;
    }
    if (slot.startTime > slot.endTime) {
      return false;
    }
  }
  return true;
};

export const getSlotDetails = slotsArray => {
  const updatedArray = [];
  slotsArray.forEach(value => {
    const slotValue = {
      startTime: value.start_time ?? '',
      endTime: value.end_time ?? '',
      amount: value.amount ?? 0,
      type: value.type ?? 1,
    };
    updatedArray.push(slotValue);
  });
  return updatedArray;
};

export const roundOffTwoDecimals = val => {
  return Math.round(val * 100) / 100;
};

export const formatAmountInRupees = val => {
  if (typeof val === 'string' || val instanceof String) {
    return `₹${val}`;
  }
  const roundedVal = Math.round(val * 100) / 100;
  return `₹${roundedVal.toLocaleString('en-IN')}`;
};

export const getPaymentRequestLogStatusMessage = status => {
  switch (status) {
    case paymentRequestEnum.EXPIRED:
      return 'Payment Link is expired. Please contact POC to re-send payment link';
    case paymentRequestEnum.INACTIVE:
      return 'Payment Link is not active. Please contact POC to re-send payment link';
    case paymentRequestEnum.PAID:
      return 'Payment has been successfully made';
    default:
      return '';
  }
};

export const getStatusForInvoice = invoice => {
  if (invoice.status === invoicesStatusEnum.PAYMENT_PENDING) {
    return (
      <Tooltip
        position='bottom'
        label={`${formatAmountInRupees(
          invoice.amount_to_be_approved ?? 0,
        )} transferred via bank is pending for approval`}
        appearance='light'
        size='big'
        style={{
          fontSize: '12px',
          maxWidth: '180px',
        }}
      >
        <StatusContainer status={invoicesStatusEnum[invoice.status]}>
          {statusLabels[invoicesStatusEnum[invoice.status]]}
        </StatusContainer>
      </Tooltip>
    );
  }
  return (
    <StatusContainer status={invoicesStatusEnum[invoice.status]}>
      {statusLabels[invoicesStatusEnum[invoice.status]]}
    </StatusContainer>
  );
};

// Temporary
export const getAmountApprovalPendingForInvoice = invoice => {
  const amountApprovalPending =
    invoice.payable_amount - invoice.paid_amount - invoice.pending_amount;
  if (amountApprovalPending === 0) {
    return ' - ';
  }
  return formatAmountInRupees(Math.max(0, amountApprovalPending));
};

export const formatEventsAmountValue = (event, amountState, toBeDownloaded) => {
  const isEventTerminated =
    event.status === topupsStatusEnum.TOPUP_EXPIRED_SUCCESS ||
    event.status === topupsStatusEnum.COMPLETED_SUCCESS ||
    event.status === topupsStatusEnum.DELETED_SUCCESS ||
    event.status === topupsStatusEnum.PAUSED_SUCCESS;

  let amountVal = event.total_amount.value - event.disbursed_amount.value;
  if (toBeDownloaded) amountVal = String(amountVal);

  if (
    (isEventTerminated && amountState === eventsAmountEnum.RELEASED) ||
    (!isEventTerminated && amountState === eventsAmountEnum.PENDING)
  ) {
    return formatAmountInRupees(amountVal);
  }
  return formatAmountInRupees(0);
};

export const formatReferenceIDForPayments = data => {
  if (data.reference_id === '') {
    return ' - ';
  }
  if (sourceToCreditType(data.source) === ONLINE) {
    return data.reference_id;
  }
  return maskUptoLastNDigits(data.reference_id, 14);
};

export const formatPOIForProgram = POIAddress => {
  const POIAddArray = POIAddress.split(',');
  let formattedPOI = '';
  if (POIAddArray.length !== 0) {
    formattedPOI = `${POIAddArray[0]}`;
    if (
      POIAddArray.length >= 2 &&
      POIAddArray[0].length + POIAddArray[1].length <= 30
    ) {
      formattedPOI = `${POIAddArray[0]}, ${POIAddArray[1]}`;
    }
  }
  return formattedPOI;
};

export const checkAmountInEachSlotWithBudget = (slots, budget) => {
  for (let i = 0; i < slots.length; i += 1) {
    if (parseInt(slots[i].amount, Number) > parseInt(budget, Number))
      return false;
  }
  return true;
};
export const amountBlockedForTopup = row => {
  if (
    topupsStatusEnum[row.status] === 'SCHEDULED_FUNDSBLOCKED' ||
    topupsStatusEnum[row.status] === 'PROCESSING' ||
    topupsStatusEnum[row.status] === 'PARTIALLY_EXECUTED'
  ) {
    return formatAmountInRupees(
      row.total_amount.value - row.disbursed_amount.value,
    );
  }
  return ' - ';
};

export const checkValidDate = dateStr => {
  const date = new Date(dateStr);
  return date.toString() !== 'Invalid Date' && date.getFullYear() !== 2001;
};

export const checkFileTypeSize = file => {
  return new Promise((resolve, reject) => {
    const ext = file.name.match(/\.[0-9a-z]+$/i)[0];
    const validateType = ['.csv'].includes(ext);
    const validateSize = file.size <= 5242880;

    if (file) {
      resolve(validateType && validateSize);
    } else {
      const noFileErr = new Error(wrongFormat);
      reject(noFileErr);
    }
  });
};

export const clearInputValue = () => {
  document.getElementById('upload-file').value = '';
};

export const currenyFormatter = amount => {
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    symbol: '₹',
    currency: 'INR',
  });

  return formatter.format(amount);
};

export const searchWithName = (arr = [], searchTerm = '', keyFields = []) => {
  let searchResults = arr;
  if (searchTerm && keyFields.length !== 0 && arr.length !== 0) {
    searchResults = arr.filter(obj => {
      return keyFields.find(keyField => {
        if (
          String(obj[keyField])
            .toLowerCase()
            .includes(searchTerm.trim().toLowerCase())
        )
          return obj;
        return null;
      });
    });
  }
  return searchResults;
};

export const prependZero = v => {
  if (v <= 9) {
    return `0${v}`;
  }
  return `${v}`;
};

const empRows = [
  ['emailId', 'employeeName', 'contact'],
  ['rishabh@zomato.com', 'Rishabh', '9999999999'],
  ['achin@zomato.com', 'Achin', '9999999999'],
];

const csvEmpContent = `data:text/csv;charset=utf-8,${empRows
  .map(e => e.join(','))
  .join('\n')}`;

const encodedEmpUri = encodeURI(csvEmpContent);
const Emplink = document.createElement('a');
Emplink.setAttribute('href', encodedEmpUri);
Emplink.setAttribute('download', 'sample_employee_data.csv');
document.body.appendChild(Emplink);

export const downloadCSV = () => Emplink.click();

const groupRows = [
  ['emailId'],
  ['rahul@zomato.com'],
  ['pooja@zomato.com'],
  ['neha@zomato.com'],
];

const csvGroupContent = `data:text/csv;charset=utf-8,${groupRows
  .map(e => e.join(','))
  .join('\n')}`;

const encodedGrpUri = encodeURI(csvGroupContent);
const Grplink = document.createElement('a');
Grplink.setAttribute('href', encodedGrpUri);
Grplink.setAttribute('download', 'sample_team_data.csv');
document.body.appendChild(Grplink);

export const downloadGroupCSV = () => Grplink.click();

const formatCSVItemValue = value => {
  if (value === undefined) {
    return ' - ';
  }
  if (
    (typeof value === 'string' || value instanceof String) &&
    value.includes(',')
  )
    return ' - ';
  return value;
};

export const convertArrayOfObjectsToCSV = (array, headKeys, headValues) => {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = array.length ? headKeys : [];

  result = '';
  result += headValues.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;

      result += formatCSVItemValue(item[key]);
      ctr += 1;
    });
    result += lineDelimiter;
  });

  return result;
};

export const exportCSV = (dataArray, tableName, headColumns) => {
  const link = document.createElement('a');
  const headKeys = headColumns.map(col => col.key);
  const headValues = headColumns.map(col => col.value);
  let csv = convertArrayOfObjectsToCSV(dataArray, headKeys, headValues);
  if (csv == null) return;

  const filename = `${tableName}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
};

export const maskUptoLastNDigits = (text, N) => {
  if (text.length < N) {
    return text;
  }
  return `${text.substring(text.length - N)}`;
};

export const maskUptoFirstNDigits = (text, N) => {
  return `${text.substring(0, N)}`;
};

export const truncateUptoNDigits = (text, N) => {
  if (text.length < N) {
    return text;
  }
  return `${text.substring(0, N)}...`;
};

export const checkValidExecutionDate = dateStr => {
  const date = new Date(dateStr);
  // we gate execution date as 0001-01-01 when the date is invalid
  return date.getFullYear() !== 2001;
};

export const includesOption = (filters, option) => {
  for (let i = 0; i < filters.length; i += 1) {
    for (let j = 0; j < option.value.length; j += 1) {
      if (filters[i].value[j] === option.value[j]) {
        return true;
      }
    }
  }
  return false;
};
export const indexOfOption = (filters, option) => {
  for (let i = 0; i < filters.length; i += 1) {
    for (let j = 0; j < option.value.length; j += 1) {
      if (filters[i].value[j] === option.value[j]) {
        return i;
      }
    }
  }
  return -1;
};

export const getOrdinal = n => {
  let ord = 'th';
  if (n % 10 === 1 && n % 100 !== 11) {
    ord = 'st';
  } else if (n % 10 === 2 && n % 100 !== 12) {
    ord = 'nd';
  } else if (n % 10 === 3 && n % 100 !== 13) {
    ord = 'rd';
  }
  return ord;
};

export const dateSortableFormat = dateStr => {
  const date = new Date(dateStr);
  return date;
};

export const formatDateSorting = dateStr => {
  if (dateStr === null || dateStr === undefined) {
    return ' ';
  }
  const dateVal = dateStr.split('.')[0];
  return new Date(dateVal);
};

export const actionBtnListTopMargin = val => {
  switch (val) {
    case 1:
      return '0px';
    case 2:
      return '-10px';
    case 3:
      return '30px';
    default:
      return '0px';
  }
};

export const queryVariableValue = variable => {
  const hrefArr = window.location.href.split('?');
  if (hrefArr.length <= 1) {
    return [false, ''];
  }
  const vars = hrefArr[1].split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return [true, pair[1]];
    }
  }
  return [false, ''];
};

// TODO: need to remove this check when we add a switch
export const checkIfLimitFlowPresent = applicableFlows => {
  for (let i = 0; i < applicableFlows.length; i += 1)
    if (applicableFlows[i] === currentFlowTypeEnum.FLOW_TYPE_LIMIT) {
      return true;
    }
  return false;
};

export const getAvailableWorkspaceLimit = workspace => {
  const prepaidLimit = workspace?.prepaid_limit ?? 0;
  const creditLimit = workspace?.credit_limit ?? 0;
  const usedLimit = workspace?.used_limit ?? 0;
  return formatAmountInRupees(prepaidLimit + creditLimit - usedLimit);
};

export const getCycleAmount = plan => {
  switch (plan.cycle_type) {
    case cycleTypeEnum.WEEKLY:
      return `${formatAmountInRupees(plan.weekly_amount)}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${formatAmountInRupees(plan.monthly_amount)}/month`;
    case cycleTypeEnum.DAILY:
      return `${formatAmountInRupees(plan.daily_amount)}/day`;
    default:
      return `₹0`;
  }
};

export const getCycleAmountForCSV = plan => {
  switch (plan.cycle_type) {
    case cycleTypeEnum.WEEKLY:
      return `${plan.weekly_amount}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${plan.monthly_amount}/month`;
    case cycleTypeEnum.DAILY:
      return `${plan.daily_amount}/day`;
    default:
      return `₹0`;
  }
};

export const getCycleFrequency = plan => {
  switch (plan.cycle_type) {
    case cycleTypeEnum.WEEKLY:
      return `Every ${
        weekDays[new Date(plan.start_date.replace(' IST', '')).getDay()]
      }`;
    case cycleTypeEnum.MONTHLY:
      return `${new Date(
        plan.start_date.replace(' IST', ''),
      ).getDate()}${getOrdinal(
        new Date(plan.start_date.replace(' IST', '')).getDate(),
      )} ${'of every month'}`;
    case cycleTypeEnum.DAILY:
      return `Everyday`;
    default:
      return ` - `;
  }
};

export const getReviewProgramCycleAmount = (
  cycleType,
  amountWeekly,
  amountMonthly,
  amountDaily,
) => {
  switch (cycleType) {
    case cycleTypeEnum.WEEKLY:
      return `${formatAmountInRupees(amountWeekly)}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${formatAmountInRupees(amountMonthly)}/month`;
    case cycleTypeEnum.DAILY:
      return `${formatAmountInRupees(amountDaily)}/day`;
    default:
      return ` - `;
  }
};

export const getReviewProgramTopUpInfo = (startDate, cycleType) => {
  const monthlyStartDate = new Date(startDate.replace(' IST', '')).getDate();
  const ordinalForStartDate = getOrdinal(monthlyStartDate);
  const weeklyStartDay =
    weekDays[new Date(startDate.replace(' IST', '')).getDay()];
  switch (cycleType) {
    case cycleTypeEnum.WEEKLY:
      return `every ${weeklyStartDay}`;
    case cycleTypeEnum.MONTHLY:
      return `on ${monthlyStartDate}${ordinalForStartDate} of every month`;
    case cycleTypeEnum.DAILY:
      return 'every day';
    default:
      return ` - `;
  }
};

export const getValueForKey = (array, key) => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i].key === key) {
      if (
        array[i].value !== undefined &&
        (array[i].value.length > 15 || array[i].value.split(',').length > 1)
      ) {
        return (
          <Tooltip
            position='top'
            showTooltip
            label={formatMultiSelectAnswers(array[i].value, ',')}
            className='tooltipInfo'
            appearance='light'
            size='small'
            style={{
              marginRight: '10px',
              fontSize: '12px',
              borderRadius: '10px',
              width: '250px',
            }}
          >
            {' '}
            {array[i].value.split(',').length > 1 ? (
              <div
                style={{
                  borderBottom: '1px dashed #999',
                  textDecoration: 'none',
                }}
              >
                {' '}
                {`${array[i].value.split(',').length} selected`}{' '}
              </div>
            ) : (
              truncateUptoNDigits(array[i].value, 15)
            )}
          </Tooltip>
        );
      }
      return array[i].value;
    }
  }
  return ' - ';
};

export const formatMultiSelectAnswers = (answer, delimiter) => {
  if (!answer || answer === undefined) return ' - ';
  const ansArray = answer.split(',');
  let formattedAnswer = '';
  for (let i = 0; i < ansArray.length - 1; i += 1) {
    formattedAnswer += `${ansArray[i]}${delimiter} `;
  }
  formattedAnswer += ansArray[ansArray.length - 1];
  return formattedAnswer;
};

export const capitalizeFirstLetter = str => {
  if (str.length === 0) {
    return ' ';
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatQuestionsColumn = quesHead => {
  const strArr = quesHead.split(' ');
  if (strArr.length === 0) {
    return ' ';
  }
  if (strArr.length === 1) {
    return capitalizeFirstLetter(strArr[0]);
  }
  if (strArr.length === 2) {
    return `${capitalizeFirstLetter(strArr[0])} ${strArr[1].toLowerCase()}`;
  }
  return `${capitalizeFirstLetter(strArr[0])} ${strArr[1].toLowerCase()}...`;
};

export const getCurrentDateTime = () => {
  const currentDate = new Date();
  return `${currentDate
    .toLocaleDateString()
    .split('/')
    .join('-')} ${currentDate.toLocaleTimeString()}`;
};

export const isConnectedToStagging = () => {
  const cookies = document.cookie.split(';');
  if (cookies.length === 0) {
    return false;
  }
  for (let i = 0; i < cookies.length; i += 1) {
    if (cookies[i].split('=')[0].trim() === FORCESERVER) {
      return true;
    }
  }
  return false;
};

export const payOnlineInvoice = invoice => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  if (
    invoice.status === invoicesStatusEnum.PARTIALLY_PAID ||
    invoice.status === invoicesStatusEnum.GENERATED_UNPAID
  ) {
    return (
      <div style={{ marginLeft: '15px' }}>
        <InvoiceOnlineContainer onClick={() => setIsModalVisible(true)}>
          Pay now
        </InvoiceOnlineContainer>
        {isModalVisible && (
          <OnlinePaymentModal
            isInvoiceSelected
            invoice={invoice}
            closeModal={() => setIsModalVisible(false)}
            heading='Pay online'
          />
        )}
      </div>
    );
  }
  return <div> </div>;
};

export const filterCurrentData = (val, currentFilters) => {
  let flag = false;
  currentFilters.forEach(filter => {
    for (let i = 0; i < filter.value.length; i += 1)
      if (val.status === filter.value[i]) flag = true;
  });
  return flag;
};

export const zipFiles = async (fileLinks, zipFileName) => {
  const zip = new JSZip();
  const fetchFile = async ({ url, mimeType }) => {
    try {
      const response = await fetch(url, {
        mode: 'cors',
        headers: {
          'Content-Type': mimeType,
        },
      });
      console.log(response);
      if (!response.ok)
        throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
      const blob = await response.blob();
      return new Blob([blob], { type: mimeType }); // Ensure the correct MIME type
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  };
  for (let i = 0; i < fileLinks.length; i += 1) {
    const fileBlob = fetchFile(fileLinks[i]);
    if (!fileBlob) {
      console.error(`Skipping file due to fetch error: ${fileLinks[i].url}`);
    }
    zip.file(fileLinks[i].name, fileBlob, { binary: true });
  }

  zip
    .generateAsync({ type: 'blob' })
    .then(content => {
      saveAs(content, zipFileName);
    })
    .catch(error => {
      console.error('Error generating ZIP:', error);
      // error toast
    });
};

export const formatBudgetAmount = (budget, cycleType) => {
  switch (cycleType) {
    case cycleTypeEnum.DAILY:
      return `${formatAmountInRupees(budget)}/day`;
    case cycleTypeEnum.WEEKLY:
      return `${formatAmountInRupees(budget)}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${formatAmountInRupees(budget)}/month`;
    default:
      return `${formatAmountInRupees(budget)}`;
  }
};

export const employeeTableValueForFlowType = (data, ppiValue, limitValue) => {
  if (data.limit_group_id !== '') {
    return limitValue !== '' ? limitValue : ' - ';
  }
  return ppiValue !== '' ? ppiValue : ' - ';
};

export const clearCookie = async cookieName => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
